import React, { FC, ReactElement } from "react";
import { DrugCostInfo, PharmacyType, PlanType, Redaction } from "../../@types";
import { $$, isMedicareAdvantageType, isPdPlanType } from "../../helpers";
import { FeatureSubtitle } from "./FeatureSubtitle";
import { SuppressionHandler } from "..";

export type DrugCoverageProps = {
  drugCostInfo: DrugCostInfo;
  drugsCovered: ReactElement;
  pharmacyType: PharmacyType;
  plan_type: PlanType;
  redactions: Redaction[];
  pdpUseRetailMessaging: boolean;
};

/**
 * `pdpUseRetailMessaging` is used when `plan_type` is `PlanType.PDP`,
 * becuase it may be rendered 2x, once for MO and once for retail
 */
export const DrugCoverage: FC<DrugCoverageProps> = ({
  drugCostInfo,
  drugsCovered,
  pharmacyType,
  plan_type,
  redactions,
  pdpUseRetailMessaging,
}) => {
  const { lowest_mail_total, lowest_retail_total } = drugCostInfo;
  const lowestMailNum = Number(lowest_mail_total);
  const lowestRetailNum = Number(lowest_retail_total);

  const formattedLowestMail = isNaN(lowestMailNum)
    ? lowest_mail_total
    : $$(lowestMailNum);
  const formattedLowestRetail = isNaN(lowestRetailNum)
    ? lowest_retail_total
    : $$(lowestRetailNum);

  const isMailOnly = pharmacyType === PharmacyType.MAIL;

  let cost: string | number | null = null;

  if (isMedicareAdvantageType(plan_type)) {
    cost = isMailOnly ? formattedLowestMail : formattedLowestRetail;
  }

  if (isPdPlanType(plan_type)) {
    cost = pdpUseRetailMessaging ? formattedLowestRetail : formattedLowestMail;
  }

  return cost ? (
    <SuppressionHandler redactions={redactions} suppressOnlyDrugPricing>
      <div className="mct-c-what-youll-pay__cost">{cost}</div>
      <FeatureSubtitle className="mct-c-what-youll-pay__covered">
        {drugsCovered}
      </FeatureSubtitle>
    </SuppressionHandler>
  ) : null;
};
